import { Controller } from "react-hook-form";
import { useState } from "react";
import {
  Autocomplete,
  FormHelperText,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";

import { ComponentTypes } from "../FormTypes";
import { ListOptions } from "../../models/Master";
import { TextFieldStyle } from "../../routes/CreatePriorAuth/style/style";
import { FaChevronUpIcon, FaCircleUserIcon } from "../styles/styles";

export const FormSelectAutocomplete = ({
  control,
  helper,
  name,
  list,
  style,
  onChangeHandler,
  handleInputChange,
  placeholder,
  disabled,
  clearErrors
}: ComponentTypes) => {
  const [open, setOpen] = useState(false);

  const handleIconClick = () => {
    setOpen(!open);
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={helper || {}}
      render={({ field, fieldState: { error } }) => (
        <>
          <Autocomplete
            {...field}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            freeSolo={false}
            id={`${name}-list`}
            disableClearable={false}
            disabled={disabled}
            options={list}
            onBlur={() => {
              field.onBlur();
              setOpen(false);
            }}
            value={
              (list && list.find((option) => option.value === field.value)) ||
              null
            }
            getOptionLabel={(option: ListOptions | string) =>
              typeof option === "string" ? option : option.label
            }
            onChange={(_e: any, value: any) => {
              field.onChange(value ? value.value : null);
              if (clearErrors) clearErrors(name);
              if (onChangeHandler) onChangeHandler(_e, value);
            }}
            onInputChange={handleInputChange}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  endAdornment: !disabled && (
                    <InputAdornment position="end">
                      <IconButton onClick={handleIconClick}>
                        {!open ? <FaCircleUserIcon /> : <FaChevronUpIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                placeholder={placeholder}
                sx={
                  disabled
                    ? TextFieldStyle(false)
                    : {
                        ...style,
                        "& .MuiOutlinedInput-root": {
                          paddingRight: "10px !important",
                        },
                        "& .MuiAutocomplete-inputRoot": {
                          paddingRight: "10px !important",
                        },
                      }
                }
              />
            )}
          />
          {error?.message && (
            <FormHelperText error>{error.message}</FormHelperText>
          )}
        </>
      )}
    />
  );
};
